import * as React from 'react';

import { css, StyleSheet } from 'aphrodite';
import { Container, Row } from 'reactstrap';
import { RouteComponentProps, withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { bindActionCreators, Dispatch } from 'redux';
import { Lottie } from '@alfonmga/react-lottie-light-ts';
import { isMobile } from 'react-device-detect';
import VerifyAccess from '../../domaindriven/specialaccess/containers/VerifySpecialAccess';
import IconLandingRightArrow from '../../assets/icons/IconLandingRightArrow';
import newtheme from '../../newtheme';
import { MpTrackingButtons } from '../../config/buttons';
import { openModal } from '../../actions/modal';
import IUser from '../../types/models/IUser';
import { IState } from '../../reducers';
import { mpTrackButtonClick } from '../../tracking/mixpanel';
import config from '../../config';
import ModalTypes from '../../types/ModalTypes';
import IGiftLink from '../../types/models/IGiftLink';
import * as mouseScrollAnim from '../../assets/lottie/mouseScrollAnim.json';
import noaXGo1 from '../../assets/images/misc/noaXGo1.png';
import ISubscriptionProduct from '../../domaindriven/subscribe/types/ISubscriptionProduct';
import { getSelectedSubscriptionProduct } from '../../domaindriven/subscribe/state/selectors';
import { ILandingPageHero } from '../../domaindriven/landing/types/ILandingPageHero';

interface IPropsFromState {
    user?: IUser;
    giftLink?: IGiftLink;
    subscriptionProduct?: ISubscriptionProduct;
}

interface IPropsFromDispatch {
    openModal: typeof openModal;
}

interface ILocalProps {
    isGo1: boolean;
    sectionData: ILandingPageHero;
}

interface ILocalState {}

class LandingPageNewTopSection extends React.Component<
    ILocalProps & IPropsFromState & IPropsFromDispatch & RouteComponentProps,
    ILocalState
> {
    public onButtonClicked = () => {
        const { subscriptionProduct } = this.props;

        if (
            subscriptionProduct &&
            subscriptionProduct.metadata.homePage &&
            subscriptionProduct.metadata.homePage.redirectToPage
        ) {
            if (this.props.user || !subscriptionProduct.metadata.homePage.showSignup) {
                this.props.history.push(subscriptionProduct.metadata.homePage.redirectToPage);
                return;
            }

            this.showSignup();
            return;
        }

        if (this.props.user) {
            this.props.history.push(config.routes.homeWebPlayer);
            return;
        }

        this.showSignup();
    };

    public showSignup = () => {
        mpTrackButtonClick(MpTrackingButtons.SHOW_SIGNUP_HERO);

        this.props.openModal(ModalTypes.SignUp);
    };

    public onSubmit = (evt: React.FormEvent<HTMLFormElement>) => {
        evt.preventDefault();
    };

    public renderGo1HeroContent = () => (
        <div>
            <img alt="Noa X Go1" src={noaXGo1} className={css(stylesGo1.logo)} />
            <h1 className={css(styles.heading, stylesGo1.heading)}>
                Thousands of <br className={css(newtheme.coreStyles.hideTiny)} />
                audio articles, <br className={css(newtheme.coreStyles.hideTiny)} />
                at your fingertips
            </h1>
            <h2 className={css(styles.subHeading, stylesGo1.subHeading)}>
                Get free access to Noa Premium with your
                <br />
                work email, courtesy of Go1.
            </h2>
            <VerifyAccess />
        </div>
    );

    public renderGiftLinkHeroContent = (giftLink: IGiftLink) => (
        <>
            <div>
                <h1 className={css(styles.headingGiftLink)}>{giftLink.title}</h1>
                <h2 className={css(styles.subHeading)}>
                    {giftLink.subTitle || 'Listen to thought-provoking journalism that you don’t have time to read.'}
                </h2>
            </div>
            <button type="button" className={css(styles.mainButton)} onClick={this.showSignup}>
                {giftLink.buttonText} <IconLandingRightArrow className={css(styles.arrowIcon)} />
            </button>
        </>
    );

    public renderRegularHeroContent = () => {
        const { subscriptionProduct, sectionData } = this.props;

        return (
            <>
                <div>
                    {subscriptionProduct &&
                        subscriptionProduct.metadata.homePage.showLogo &&
                        subscriptionProduct.metadata.general.offerLogo && (
                            <img
                                alt="Offer logo"
                                src={subscriptionProduct.metadata.general.offerLogo}
                                className={css(styles.offerLogo)}
                            />
                        )}
                    <h1 className={css(styles.heading)}>
                        {sectionData.title ? (
                            sectionData.title
                        ) : (
                            <>
                                Never miss an
                                <br />
                                opportunity to
                                <br />
                                know more.
                            </>
                        )}
                    </h1>
                    <h2 className={css(styles.subHeading)}>
                        {sectionData.subTitle ? (
                            sectionData.subTitle
                        ) : (
                            <>Listen to thought-provoking journalism that you don’t have time to read.</>
                        )}
                    </h2>
                </div>
                <div className={css(styles.buttonWrapper)}>
                    <button type="button" className={css(styles.mainButton)} onClick={this.onButtonClicked}>
                        {sectionData.buttonText ? sectionData.buttonText : 'Start Listening'}{' '}
                        <IconLandingRightArrow className={css(styles.arrowIcon)} />
                    </button>
                </div>
            </>
        );
    };

    public getHeroContent = () => {
        const { giftLink, isGo1 } = this.props;

        if (isGo1) {
            return this.renderGo1HeroContent();
        }

        if (giftLink) {
            return this.renderGiftLinkHeroContent(giftLink);
        }

        return this.renderRegularHeroContent();
    };

    public getStandardHeroBgImage = () => {
        const { sectionData } = this.props;

        const bgImage = isMobile ? sectionData.backgroundImage.mobile : sectionData.backgroundImage.desktop;

        return `url("${bgImage}")`;
    };

    public renderMobileFirstHero() {
        return (
            <div
                className={css(styles.main)}
                style={{ background: isMobile ? 'url("/OfferTopImageMobile.webp")' : 'url("/OfferTopImage.webp")' }}>
                <Container className={css(styles.fullHeight)}>
                    <Row className={css(styles.fullHeight, styles.row)}>
                        <div className={css(styles.contentMobile)}>
                            {this.getHeroContent()}

                            <div className={css(styles.scrollWrapper)}>
                                <Lottie
                                    config={{
                                        loop: true,
                                        autoplay: true,
                                        // @ts-ignore
                                        animationData: mouseScrollAnim.default,
                                    }}
                                    height={isMobile ? '51px' : '30px'}
                                    width={isMobile ? '51px' : '30px'}
                                />
                                <p className={css(styles.scrollText)}>Scroll down to learn more</p>
                            </div>
                        </div>
                    </Row>
                </Container>
            </div>
        );
    }

    public renderStandardHero() {
        const bgImage = this.getStandardHeroBgImage();

        return (
            <div className={css(styles.main, styles.standardHeroMain)} style={{ background: '#021524' }}>
                <Container className={css(styles.containerMobileStandardHero)}>
                    {isMobile && (
                        <Row className={css(styles.standardHeroImageContainer)} style={{ backgroundImage: bgImage }}>
                            <img src="/LandingPagePhoneMobile.png" className={css(styles.phoneImage)} alt="Phone" />
                        </Row>
                    )}
                    <Row>
                        <div className={css(styles.contentMobileStandardHero)}>{this.getHeroContent()}</div>
                    </Row>
                </Container>

                {!isMobile && (
                    <div className={css(styles.standardHeroImageContainer)} style={{ backgroundImage: bgImage }}>
                        <img src="/LandingPagePhoneDesktop.png" className={css(styles.phoneImage)} alt="Phone" />
                    </div>
                )}
            </div>
        );
    }

    public render() {
        const { sectionData } = this.props;

        if (sectionData.style === 'MOBILE_FIRST') {
            return this.renderMobileFirstHero();
        }

        return this.renderStandardHero();
    }
}

const styles = StyleSheet.create({
    main: {
        [newtheme.cssBreakpoints.tiny]: {
            paddingTop: 75,
            paddingBottom: 40,
            backgroundPosition: '0% 80%',
            maxHeight: 650,
        },
        [newtheme.cssBreakpoints.smallerThanTiny]: {
            backgroundPosition: '0% 85%',
        },
        [newtheme.cssBreakpoints.minuscule]: {
            paddingBottom: 20,
            maxHeight: 600,
            backgroundPosition: '0% 70%',
        },
        position: 'relative',
        backgroundPosition: 'center',
        backgroundSize: 'cover',
        backgroundRepeat: 'no-repeat',
        color: 'white',
        height: '100vh',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
    },
    standardHeroMain: {
        [newtheme.cssBreakpoints.tiny]: {
            maxHeight: 'none',
        },
        [newtheme.cssBreakpoints.minuscule]: {
            maxHeight: 'none',
        },
    },
    standardHeroImageContainer: {
        [newtheme.cssBreakpoints.tiny]: {
            width: '110%',
            flex: 1.1,
            backgroundPosition: 'center bottom',
            position: 'relative',
            top: -50,
            bottom: 'auto',
            left: 'auto',
            right: 'auto',
            overflow: 'visible',
        },
        position: 'absolute',
        top: 30,
        bottom: 0,
        right: 0,
        width: '52%',
        backgroundSize: 'cover',
        overflow: 'hidden',
    },
    phoneImage: {
        [newtheme.cssBreakpoints.large]: {
            width: '500px',
            bottom: 40,
        },
        [newtheme.cssBreakpoints.medium]: {
            width: '420px',
            bottom: 30,
            left: 20,
        },
        [newtheme.cssBreakpoints.small]: {
            width: '350px',
            left: 0,
            bottom: 50,
        },
        [newtheme.cssBreakpoints.tiny]: {
            width: '100%',
            maxWidth: '450px',
            bottom: -50,
            right: 0,
            left: 'auto',
        },
        [newtheme.cssBreakpoints.iPhoneSE]: {
            width: '95%',
        },
        width: '550px',
        position: 'absolute',
        bottom: 0,
        left: 0,
        zIndex: 2,
    },
    fullHeight: {
        height: '100%',
    },
    row: {
        position: 'relative',
    },
    contentMobile: {
        [newtheme.cssBreakpoints.tiny]: {
            justifyContent: 'space-between',
            width: '90%',
            marginLeft: '5%',
        },
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'flex-start',
        width: '52%',
    },
    containerMobileStandardHero: {
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
    },
    contentMobileStandardHero: {
        [newtheme.cssBreakpoints.tiny]: {
            justifyContent: 'flex-end',
            width: '90%',
            marginLeft: '5%',
        },
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'flex-start',
        width: '55%',
        zIndex: 1,
    },
    headingGiftLink: {
        [newtheme.cssBreakpoints.large]: {
            fontSize: 45,
        },
        [newtheme.cssBreakpoints.medium]: {
            fontSize: 35,
            marginBottom: 10,
        },
        [newtheme.cssBreakpoints.small]: {
            fontSize: 32,
        },
        [newtheme.cssBreakpoints.tiny]: {
            fontSize: 30,
        },
        [newtheme.cssBreakpoints.minuscule]: {
            fontSize: 25,
            marginBottom: 5,
        },
        fontSize: 55,
        fontWeight: 500,
        marginTop: 40,
        marginBottom: 18,
    },
    headingPublisherLink: {
        [newtheme.cssBreakpoints.large]: {
            fontSize: 50,
        },
        [newtheme.cssBreakpoints.medium]: {
            fontSize: 36,
            marginBottom: 10,
        },
        [newtheme.cssBreakpoints.small]: {
            fontSize: 32,
        },
        [newtheme.cssBreakpoints.tiny]: {
            fontSize: 30,
        },
        [newtheme.cssBreakpoints.minuscule]: {
            fontSize: 25,
            marginBottom: 5,
        },
        fontSize: 57,
        fontWeight: 500,
        marginTop: 40,
        marginBottom: 18,
        whiteSpace: 'pre-line',
    },
    heading: {
        [newtheme.cssBreakpoints.large]: {
            fontSize: 55,
            marginTop: 30,
        },
        [newtheme.cssBreakpoints.medium]: {
            fontSize: 42,
            marginTop: 10,
            marginBottom: 10,
        },
        [newtheme.cssBreakpoints.small]: {
            fontSize: 32,
        },
        [newtheme.cssBreakpoints.tiny]: {
            fontSize: 36,
            marginTop: 0,
        },
        [newtheme.cssBreakpoints.minuscule]: {
            fontSize: 30,
            marginBottom: 5,
        },
        fontSize: 65,
        fontWeight: 500,
        marginTop: 30,
        marginBottom: 18,
    },
    subHeading: {
        [newtheme.cssBreakpoints.medium]: {
            fontSize: 16,
            marginBottom: 20,
        },
        [newtheme.cssBreakpoints.small]: {
            fontSize: 14,
            marginBottom: 25,
        },
        [newtheme.cssBreakpoints.smallerThanTiny]: {
            fontSize: 13,
        },
        [newtheme.cssBreakpoints.minuscule]: {
            fontSize: 12,
        },
        fontSize: 21,
        fontWeight: 400,
        color: 'rgba(255, 255, 255, 0.6)',
        lineHeight: '171%',
        marginBottom: 35,
        whiteSpace: 'pre-line',
    },
    buttonWrapper: {
        [newtheme.cssBreakpoints.tiny]: {
            width: '100%',
        },
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        position: 'relative',
        marginBottom: 20,
    },
    mainButton: {
        [newtheme.cssBreakpoints.medium]: {
            fontSize: 16,
            padding: '12px 25px',
        },
        [newtheme.cssBreakpoints.small]: {
            fontSize: 14,
            padding: '10px 20px',
            borderRadius: 10,
        },
        [newtheme.cssBreakpoints.tiny]: {
            width: '100%',
        },
        ':hover': {
            backgroundColor: 'white',
            color: 'black',
            stroke: 'black',
        },
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: newtheme.colors.primaryBlue,
        color: 'white',
        stroke: 'white',
        border: 'none',
        borderRadius: 15,
        fontSize: 18,
        fontWeight: 500,
        padding: '20px 40px',
    },
    offerLogo: {
        [newtheme.cssBreakpoints.medium]: {
            height: 70,
        },
        [newtheme.cssBreakpoints.small]: {
            height: 60,
        },
        [newtheme.cssBreakpoints.tiny]: {
            display: 'none',
        },
        height: 86,
    },
    arrowIcon: {
        color: 'white',
        height: 31,
        width: 33,
        marginLeft: 10,
    },
    scrollWrapper: {
        [newtheme.cssBreakpoints.medium]: {
            bottom: 30,
        },
        [newtheme.cssBreakpoints.tiny]: {
            display: 'none',
        },
        ':hover': {
            cursor: 'default',
        },
        position: 'absolute',
        bottom: 50,
        left: 0,
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
    },
    scrollMouseImg: {
        width: 41,
        height: 41,
    },
    scrollText: {
        [newtheme.cssBreakpoints.small]: {
            fontSize: 14,
        },
        marginBottom: 0,
        marginLeft: 10,
        color: '#9CD6EE',
        fontSize: 18,
    },
});

const stylesGo1 = StyleSheet.create({
    subHeading: {
        color: newtheme.colors.white,
        fontWeight: 400,
        marginBottom: 35,
    },
    logo: {
        [newtheme.cssBreakpoints.medium]: {
            height: 40,
        },
        [newtheme.cssBreakpoints.small]: {
            height: 30,
        },
        [newtheme.cssBreakpoints.tiny]: {
            marginTop: 0,
        },
        height: 54,
    },
    heading: {
        [newtheme.cssBreakpoints.tiny]: {
            marginTop: 10,
        },
        marginTop: 10,
    },
    form: {
        display: 'flex',
        flexDirection: 'row',
        width: '100%',
    },
    button: {
        width: 200,
        minWidth: 200,
        padding: 0,
        borderRadius: 10,
        marginLeft: 20,
    },
});

function mapStateToProps(state: IState): IPropsFromState {
    return {
        user: state.user.user,
        giftLink: state.userSource.giftLink,
        subscriptionProduct: getSelectedSubscriptionProduct(state),
    };
}

function mapDispatchToProps(dispatch: Dispatch): IPropsFromDispatch {
    return bindActionCreators({ openModal }, dispatch);
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(LandingPageNewTopSection));
